/**
 * Shared QR overlay UI for legacy remote (v2) and remote v1.
 */

import * as QRiousModule from 'qrious';

interface QRiousCtor {
  new (opts: {
    element: HTMLCanvasElement;
    value: string;
    size?: number;
    padding?: number;
    foreground?: string;
    background?: string;
    level?: 'L' | 'M' | 'Q' | 'H';
  }): unknown;
}

export const QR_ICON =
  '<path fill="currentColor" d="M 473.261719 66.050781 C 468.820312 66.722656 458.925781 69.597656 453.777344 71.714844 C 446.828125 74.570312 441.414062 77.675781 435.042969 82.453125 C 428.507812 87.355469 338.027344 178.050781 333 184.738281 C 314.679688 209.105469 311.0625 243.746094 323.996094 270.902344 C 330.375 284.292969 331.523438 285.578125 383.625 337.679688 C 436.941406 390.996094 438.332031 392.21875 452.53125 398.324219 C 463.230469 402.921875 470.246094 404.421875 483.003906 404.84375 C 491.628906 405.128906 495.816406 404.921875 500.992188 403.957031 C 514.242188 401.480469 526.339844 396.207031 536.589844 388.4375 C 539.679688 386.09375 563.84375 362.484375 590.285156 335.96875 C 639.371094 286.746094 641.433594 284.46875 647.125 273.175781 C 657.328125 252.941406 658.742188 228.117188 650.933594 206.460938 C 647.621094 197.285156 644.398438 191.609375 636.882812 181.71875 C 631.160156 174.191406 544.503906 87.761719 537.339844 82.4375 C 529.503906 76.613281 516.765625 70.421875 507.738281 68.046875 C 501.328125 66.359375 498.453125 66.046875 487.875 65.890625 C 481.074219 65.792969 474.5 65.863281 473.261719 66.050781 M 478.136719 125.96875 C 476.285156 126.640625 473.417969 128.136719 471.769531 129.292969 C 470.117188 130.449219 448.632812 151.570312 424.027344 176.230469 C 373.472656 226.894531 375.902344 223.90625 375.902344 235.304688 C 375.902344 246.734375 373.292969 243.554688 425.523438 295.742188 C 462.9375 333.117188 472.480469 342.269531 475.511719 343.664062 C 478.511719 345.046875 480.601562 345.398438 486.003906 345.429688 C 497.351562 345.496094 494.707031 347.675781 547.265625 295 C 591.371094 250.792969 593.441406 248.597656 595.027344 244.296875 C 597.316406 238.101562 596.921875 229.484375 594.101562 224.0625 C 592.648438 221.269531 580.449219 208.628906 546.199219 174.441406 C 508.238281 136.554688 499.589844 128.285156 496.496094 126.914062 C 491.535156 124.722656 482.808594 124.273438 478.136719 125.96875 M 198.023438 340.21875 C 186.027344 342.394531 175.953125 346.433594 165.222656 353.359375 C 160.367188 356.496094 150.085938 366.386719 110.050781 406.425781 C 58.085938 458.398438 56.773438 459.863281 50.628906 472.84375 C 47.398438 479.671875 44.609375 488.621094 43.441406 495.910156 C 41.96875 505.125 42.875 522.132812 45.3125 530.953125 C 47.917969 540.367188 53.417969 551.65625 59.003906 559.054688 C 65.183594 567.234375 158.496094 660.160156 164.644531 664.253906 C 179.507812 674.15625 194.835938 678.828125 212.460938 678.828125 C 226.390625 678.828125 237.894531 676.167969 249.933594 670.164062 C 261.292969 664.5 263.796875 662.238281 312.765625 613.460938 C 339.078125 587.246094 362.550781 563.269531 364.921875 560.179688 C 377.164062 544.226562 382.816406 526.097656 381.96875 505.472656 C 381.210938 486.976562 375.574219 471.484375 364.378906 457.125 C 357.417969 448.203125 268.121094 359.273438 261.421875 354.589844 C 243.285156 341.921875 219.007812 336.417969 198.023438 340.21875 M 744.816406 340.222656 C 733.089844 342.441406 721.535156 347.285156 711.570312 354.152344 C 704.484375 359.039062 610.519531 453.050781 605.476562 460.300781 C 590.726562 481.503906 586.25 507.714844 593.1875 532.210938 C 595.484375 540.324219 601.300781 552.355469 606.019531 558.765625 C 610.726562 565.15625 700.1875 654.941406 707.890625 661.003906 C 723.285156 673.125 740.167969 678.855469 760.292969 678.789062 C 778.707031 678.730469 794.488281 673.574219 809.753906 662.617188 C 817.242188 657.246094 906.289062 568.359375 912.375 560.179688 C 920.691406 549.011719 925.253906 539.1875 927.78125 527.019531 C 933.011719 501.84375 927.484375 477.625 911.75 456.757812 C 906.414062 449.683594 817.492188 360.804688 811.21875 356.277344 C 801.171875 349.027344 791.867188 344.613281 780.191406 341.5625 C 771.085938 339.1875 753.761719 338.527344 744.816406 340.222656 M 205.558594 399.34375 C 203.820312 399.914062 200.953125 401.234375 199.1875 402.285156 C 197.421875 403.335938 175.527344 424.703125 150.535156 449.773438 C 107.097656 493.347656 105.023438 495.550781 103.4375 499.851562 C 101.023438 506.386719 101.507812 514.9375 104.589844 520.300781 C 107.945312 526.128906 195.421875 613.777344 200.863281 616.761719 C 204.652344 618.835938 205.546875 619.007812 212.460938 619.007812 C 219.285156 619.007812 220.300781 618.820312 223.773438 616.894531 C 226.484375 615.390625 240.941406 601.394531 273.703125 568.554688 C 325.628906 516.507812 322.640625 520.179688 322.613281 508.46875 C 322.589844 497.503906 324.917969 500.328125 273.324219 448.734375 C 232.503906 407.917969 226.964844 402.644531 223.023438 400.851562 C 217.722656 398.4375 210.292969 397.796875 205.558594 399.34375 M 751.992188 399.667969 C 749.898438 400.390625 746.527344 402.214844 744.496094 403.71875 C 742.46875 405.21875 721.046875 426.285156 696.898438 450.527344 C 647.15625 500.460938 649.449219 497.621094 649.441406 509.21875 C 649.4375 520 647.621094 517.796875 699.042969 569.3125 C 731.152344 601.476562 745.558594 615.410156 748.246094 616.902344 C 751.710938 618.820312 752.71875 619.007812 759.542969 619 C 765.902344 618.992188 767.605469 618.71875 770.785156 617.195312 C 773.730469 615.78125 784.046875 605.914062 818.964844 571.113281 C 843.40625 546.757812 864.5625 525.144531 865.980469 523.082031 C 869.613281 517.808594 871.3125 510.570312 870.207031 505.070312 C 869.746094 502.777344 868.804688 499.652344 868.113281 498.128906 C 866.667969 494.929688 777.84375 405.332031 773.0625 402.246094 C 767.03125 398.355469 758.726562 397.339844 751.992188 399.667969 M 478.960938 709.707031 C 470.988281 711.941406 468.574219 713.949219 443.113281 739.546875 C 413.660156 769.15625 414.058594 768.578125 414.058594 781.636719 C 414.058594 794.890625 413.535156 794.136719 443.515625 824.132812 C 470.730469 851.359375 471.683594 852.109375 481.457031 854.074219 C 484.765625 854.738281 486.917969 854.726562 490.746094 854.019531 C 500.484375 852.226562 502.527344 850.621094 528.71875 824.15625 C 545.625 807.074219 553.410156 798.675781 555.097656 795.691406 C 558.269531 790.074219 559.507812 783.125 558.402344 777.179688 C 556.574219 767.375 555.507812 766.011719 528.71875 739.148438 C 506.113281 716.472656 503.539062 714.132812 498.742188 711.84375 C 492.269531 708.761719 485.101562 707.984375 478.960938 709.707031"/>';
export const OPEN_ICON =
  '<polyline points="8 6 2 12 8 18"/><polyline points="16 6 22 12 16 18"/><line x1="12" y1="4" x2="12" y2="20"/>';
export const QR_ICON_VIEWBOX = '0 0 980.25 935.999989';
export const OPEN_ICON_VIEWBOX = '0 0 24 24';

export function qrOverlayDebug(message: string, data?: Record<string, unknown>): void {
  if (typeof console === 'undefined' || typeof console.debug !== 'function') return;
  if (typeof data === 'undefined') {
    console.debug(`[lectura-next][remote] ${message}`);
    return;
  }
  console.debug(`[lectura-next][remote] ${message}`, data);
}

export function resolvePresentationIdForRemote(getPresentationId?: () => string): string {
  const fromGetter = String(getPresentationId?.() || '').trim();
  if (fromGetter) return fromGetter;
  const revealEl = document.querySelector('.reveal');
  const fromDataAttr = String(revealEl?.getAttribute('data-lectura-presentation-id') || '').trim();
  if (fromDataAttr) return fromDataAttr;
  const fromWindow = String(
    (window as unknown as { __LECTURA_PRES_ID__?: string }).__LECTURA_PRES_ID__ || ''
  ).trim();
  if (fromWindow) return fromWindow;

  const pathParts = window.location.pathname.split('/').filter(Boolean);
  if (pathParts.length === 0) return 'deck';
  let seg = pathParts[pathParts.length - 1];
  if (seg === 'index.html' && pathParts.length >= 2) seg = pathParts[pathParts.length - 2];
  return seg || 'deck';
}

function getQRiousConstructor(): QRiousCtor | null {
  const candidate = (window as unknown as { QRious?: unknown }).QRious;
  if (typeof candidate === 'function') return candidate as QRiousCtor;

  const fromModule = (QRiousModule as unknown as { default?: unknown }).default ?? (QRiousModule as unknown);
  return typeof fromModule === 'function' ? (fromModule as QRiousCtor) : null;
}

function cropCanvasToQr(canvas: HTMLCanvasElement, outSize: number): void {
  const w = canvas.width;
  const h = canvas.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const data = ctx.getImageData(0, 0, w, h).data;

  let minX = w;
  let minY = h;
  let maxX = 0;
  let maxY = 0;

  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const i = (y * w + x) * 4;
      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];
      if (r < 250 || g < 250 || b < 250) {
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
      }
    }
  }

  const cw = maxX - minX + 1;
  const ch = maxY - minY + 1;
  if (cw <= 0 || ch <= 0) return;

  const tmp = document.createElement('canvas');
  tmp.width = outSize;
  tmp.height = outSize;
  const tctx = tmp.getContext('2d');
  if (!tctx) return;
  tctx.imageSmoothingEnabled = false;
  tctx.fillStyle = '#ffffff';
  tctx.fillRect(0, 0, outSize, outSize);
  tctx.drawImage(canvas, minX, minY, cw, ch, 0, 0, outSize, outSize);

  canvas.width = outSize;
  canvas.height = outSize;
  const outCtx = canvas.getContext('2d');
  if (!outCtx) return;
  outCtx.imageSmoothingEnabled = false;
  outCtx.drawImage(tmp, 0, 0);
}

export function ensureQrOverlay(parent: HTMLElement): HTMLElement {
  let overlay = document.getElementById('rf-qr-overlay');
  if (overlay) {
    if (overlay.parentElement !== parent) {
      parent.appendChild(overlay);
      qrOverlayDebug('Moved existing overlay to new parent', {
        parentTag: parent.tagName,
        parentClass: parent.className
      });
    }
    return overlay;
  }
  overlay = document.createElement('div');
  overlay.id = 'rf-qr-overlay';
  overlay.className = 'rf-qr-overlay lectura-qr-overlay';
  overlay.setAttribute('aria-hidden', 'true');
  parent.appendChild(overlay);
  qrOverlayDebug('Created QR overlay', { parentTag: parent.tagName, parentClass: parent.className });
  return overlay;
}

/** Spinner only — while creating a session or reconnecting MQTT. */
export function renderQrOverlayLoading(overlay: HTMLElement): void {
  overlay.innerHTML = '';
  const wrap = document.createElement('div');
  wrap.className = 'lectura-qr-loading';
  wrap.setAttribute('role', 'status');
  wrap.setAttribute('aria-live', 'polite');
  wrap.setAttribute('aria-label', 'Loading remote');
  const sp = document.createElement('div');
  sp.className = 'lectura-qr-loading-spinner';
  sp.setAttribute('aria-hidden', 'true');
  wrap.appendChild(sp);
  overlay.appendChild(wrap);
  qrOverlayDebug('QR overlay loading state');
}

export function renderQrOverlayContent(overlay: HTMLElement, remoteUrl: string): void {
  overlay.innerHTML = '';
  qrOverlayDebug('Rendering QR overlay content', { remoteUrl });

  const backdrop = document.createElement('div');
  backdrop.className = 'lectura-qr-expand-backdrop';
  backdrop.setAttribute('aria-hidden', 'true');
  const qrWrap = document.createElement('div');
  qrWrap.className = 'lectura-qr-link';
  qrWrap.title = 'Enlarge QR';
  qrWrap.setAttribute('role', 'button');
  qrWrap.setAttribute('tabindex', '0');

  const canvasSmall = document.createElement('canvas');
  qrWrap.appendChild(canvasSmall);

  const openRemote = document.createElement('a');
  openRemote.className = 'lectura-qr-open-remote-btn';
  openRemote.href = remoteUrl;
  openRemote.target = '_blank';
  openRemote.rel = 'noopener noreferrer';
  openRemote.textContent = 'open remote';

  overlay.appendChild(backdrop);
  overlay.appendChild(qrWrap);
  overlay.appendChild(openRemote);

  let qrRendered = false;
  const QRious = getQRiousConstructor();
  qrOverlayDebug('QRious availability', { available: !!QRious });
  if (QRious) {
    try {
      new QRious({
        element: canvasSmall,
        value: remoteUrl,
        size: 128,
        padding: 0,
        foreground: '#1e1b4b',
        background: '#ffffff',
        level: 'M'
      });
      cropCanvasToQr(canvasSmall, 64);
      qrOverlayDebug('QR rendered successfully', {
        smallCanvasWidth: canvasSmall.width,
        smallCanvasHeight: canvasSmall.height
      });
      qrRendered = true;
    } catch (err) {
      qrOverlayDebug('QR rendering failed', {
        error: err instanceof Error ? err.message : String(err)
      });
    }
  }

  if (!qrRendered) {
    canvasSmall.style.display = 'none';
    const fallback = document.createElement('div');
    fallback.className = 'lectura-qr-fallback';
    fallback.textContent = 'QR library not loaded';
    qrWrap.appendChild(fallback);
    qrOverlayDebug('QR fallback shown because QRious is missing');
  }

  function setExpanded(open: boolean): void {
    qrWrap.classList.toggle('lectura-qr-link-expanded', open);
    backdrop.classList.toggle('lectura-qr-expand-backdrop-open', open);
    backdrop.setAttribute('aria-hidden', open ? 'false' : 'true');
  }
  qrWrap.addEventListener('click', () => {
    setExpanded(!qrWrap.classList.contains('lectura-qr-link-expanded'));
  });
  qrWrap.addEventListener('keydown', (ev) => {
    if (ev.key === 'Enter' || ev.key === ' ') {
      ev.preventDefault();
      setExpanded(!qrWrap.classList.contains('lectura-qr-link-expanded'));
    }
  });
  backdrop.addEventListener('click', (ev) => {
    if (ev.target === backdrop) setExpanded(false);
  });
}

/**
 * Sync the “big QR” expanded state (matches click on `.lectura-qr-link`).
 * Safe when overlay is closed, loading, or DOM not yet ready (no-op).
 */
export function setQrLinkExpanded(expanded: boolean): void {
  const overlay = document.getElementById('rf-qr-overlay');
  if (!overlay) return;
  const link = overlay.querySelector('.lectura-qr-link');
  const backdrop = overlay.querySelector('.lectura-qr-expand-backdrop');
  if (!link || !backdrop) return;
  link.classList.toggle('lectura-qr-link-expanded', expanded);
  backdrop.classList.toggle('lectura-qr-expand-backdrop-open', expanded);
  backdrop.setAttribute('aria-hidden', expanded ? 'false' : 'true');
}

/** Legacy hook; v1 uses {@link renderQrOverlayLoading} + session recycle instead of an error banner. */
export function setQrOverlayMqttError(overlay: HTMLElement, show: boolean, _opts?: { onRetry?: () => void }): void {
  overlay.querySelector('.lectura-qr-mqtt-error')?.remove();
  if (!show) return;
}